import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import banner from '../assets/images/downtown.jpg';
import interior from '../assets/images/interior.jpg';

const commitments = [
  ['Verified, not just listed', 'Every property is inspected and its paperwork checked before it reaches a client.'],
  ['One point of contact', 'The person you meet first sees the deal through to handover.'],
  ['Straight advice', "If a property isn't right for you, we'll say so."],
];
const team = [
  ['Rinku Varma', 'Founder'],
  ['Drishti Varma', 'Manager'],
];

export default function About() {
  return (
    <>
      <PageHero
        image={banner}
        eyebrow="About us"
        title="Your trusted partner in Dubai real estate."
        lead="Address Collective is a Dubai-based real estate agency helping buyers, sellers, landlords and investors buy, sell or lease with confidence. You get local market knowledge, transparent advice and one dedicated contact from first enquiry to handover."
      />

      <section className="section">
        <div className="wrap grid items-center gap-16 lg:grid-cols-2 lg:gap-24">
          <Reveal>
            <p className="eyebrow text-ink/70">How we work</p>
            <span className="rule mt-5" />
            <h2 className="display mt-8 max-w-[15ch]">Built on discretion.</h2>
            <ul className="mt-10 space-y-8">
              {commitments.map(([heading, description]) => (
                <li key={heading} className="flex gap-5">
                  <span className="mt-2.5 h-px w-8 shrink-0 bg-brass" />
                  <div>
                    <h3 className="text-[1.3rem] font-normal">{heading}</h3>
                    <p className="mt-1 text-[0.97rem] text-ink/75">{description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={150} className="relative">
            <div className="absolute -bottom-5 -right-5 hidden h-full w-full border border-brass md:block" />
            <img src={interior} alt="Light-filled modern living space" loading="lazy" className="relative aspect-[5/4] w-full rounded-sm object-cover" />
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="wrap grid gap-6 md:grid-cols-2">
          <Reveal className="rounded-sm border border-ink/10 bg-paper p-8 md:p-10">
            <h2 className="display">Vision</h2>
            <p className="mt-6 text-[1.05rem] text-ink/80">To be Dubai's most trusted name in real estate, known for integrity, expertise and lasting client relationships.</p>
          </Reveal>
          <Reveal delay={120} className="rounded-sm border border-ink/10 bg-paper p-8 md:p-10">
            <h2 className="display">Mission</h2>
            <p className="mt-6 text-[1.05rem] text-ink/80">To help clients find the right address and make confident property decisions in Dubai, through transparent advice, local market knowledge and relationships built to last.</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-sand/45 py-24 md:py-32">
        <div className="wrap">
          <Reveal className="mb-14 flex flex-wrap items-end justify-between gap-6">
            <h2 className="display max-w-[10ch]">The team</h2>
          </Reveal>
          <div className="grid gap-6 md:grid-cols-2">
            {team.map(([name, role], i) => (
              <Reveal key={i} delay={i * 120} className="overflow-hidden rounded-sm bg-paper">
                <div className="flex aspect-[3/4] items-end bg-sand p-4 text-xs text-ink/60">Photo coming soon</div>
                <div className="px-6 pb-8 pt-6">
                  <h3 className="text-[1.4rem] font-normal">{name}</h3>
                  <div className="mt-1 text-sm text-ink/70">{role}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24">
        <Reveal className="wrap flex flex-wrap items-center justify-between gap-6">
          <h2 className="display max-w-[18ch]">Want to talk to the team directly?</h2>
          <Link to="/contact#enquiry-form" className="btn btn-primary">Book a consultation</Link>
        </Reveal>
      </section>
    </>
  );
}
